import coverImg from "assets/images/v156/bg.webp"
import pictureImg from "assets/images/v156/cover.webp"
import titleImg from "assets/images/v156/title.webp"

export const v156Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
  picture: pictureImg,
}
